module.exports = __webpack_public_path__ + "static/media/check.446df184.svg";